import './DashCard.css';

import { ILineChartData } from '../../../interfaces/type1/ILineChartData';
import { INavMenuRoute } from '../../../components/header/HeaderOptions';


export enum CardType
{
    SALDO,
    RECEITA, 
    DESPESA, 
    ATOS
}

export interface ICardProps
{
    Url: string, 
    SubTitle: string, 
    Title : string,
    Value: string, 
    IconClass : string
}

export default function DashCard(props: ICardProps) {
   

    let className = "Receita";
    
    return (

        <div className='Dashcard' onClick={() => window.location.pathname = `${props.Url}`}>
             <div className={`ChartDesc ${className}Card`}>
                        <h2 className={`${className}Text`}>{props.Title}</h2>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row', 
                            justifyContent: 'space-between'
                        }}>
                            <i className={`${props.IconClass} ${className}Icon`}></i>
                            <h1 className={`${className}Text`}>{props.Value}</h1>
                        </div>
                        <h4 className={`${className}Text`}>{props.SubTitle}</h4>
                    </div>
        </div>
    );

}